import type { FunctionComponent, PropsWithChildren } from 'react';
import type { DefaultTheme } from 'styled-components';
import { ThemeProvider } from 'styled-components';

const BLACK = '#363A4F';
const GRAY = '#a9aba6';
const WHITE = '#ffffff';

const YELLOW = '#eccc36';

const VERY_DARK_BLUE = '#50628B';
const DARK_BLUE = '#7084b1';
const BLUE = '#8599c5';
const LIGHT_BLUE = '#aac0e2';
const VERY_LIGHT_BLUE = '#bfd5ed';

const GREEN = '#79BEAA';
const LIGHT_GREEN = '#8fbe5e';

const VERY_DARK_RED = '#796778';
const DARK_RED = '#a16374';
const RED = '#b75570';
const LIGHT_RED = '#d3879c';

const VIOLET = '#afb7e2';

const SHADOW = 'rgba(0, 0, 0, 0.5)';
const FOG = 'rgba(112, 132, 177, 0.66)';

export const theme: DefaultTheme = {
	colors: {
		black: BLACK,
		gray: GRAY,
		white: WHITE,
		yellow: YELLOW,
		veryDarkBlue: VERY_DARK_BLUE,
		darkBlue: DARK_BLUE,
		blue: BLUE,
		lightBlue: LIGHT_BLUE,
		veryLightBlue: VERY_LIGHT_BLUE,
		green: GREEN,
		lightGreen: LIGHT_GREEN,
		veryDarkRed: VERY_DARK_RED,
		darkRed: DARK_RED,
		red: RED,
		lightRed: LIGHT_RED,
		violet: VIOLET,
		lightText: VERY_LIGHT_BLUE,
		darkText: 'rgba(30, 30, 30, 0.8)',
		shadow: SHADOW,
		fog: FOG
	},
	font: {
		default: '500 5.2vmin Lato, sans-serif',
		defaultSmall: '500 3.2vmin Lato, sans-serif',
		title: '900 10.4vmin Lato, sans-serif',
		button: 'bold 2.4vmin/3vmin Lato, sans-serif',
		tab: 'bold 4vmin/4.6vmin Lato, sans-serif',
		input: '500 5.6vmin Lato, sans-serif'
	},
	shadow: {
		bar: '2vmin 2vmin 0 0 ' + SHADOW,
		dialog: '2vmin 2vmin 0 0 ' + SHADOW,
		tab: '0.8vmin 0 ' + SHADOW,
		button: '0.8vmin 0.8vmin 0 ' + SHADOW,
		imageButton: '0.8vmin 0.8vmin 0 ' + SHADOW,
		imageButtonBorder: '0px 0px 1px ' + SHADOW,
		pointer: '1vmin 1vmin ' + SHADOW,
		textBlock: '0.8vmin 0.8vmin 0 0 ' + SHADOW,
		title: '4px 4px ' + DARK_BLUE,
		caption: '0 2px 5px ' + SHADOW,
		points: '0 2px 5px ' + SHADOW
	},
	borderWidth: {
		bar: '0.6vmin',
		season: '0.6vmin',
		button: '0.4vmin'
	}
};

interface Props {}

export const DefaultThemeProvider: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
